export const GAME_IDS = {
    BOLT_ACTION_3E: 'bolt-action-3e',
    BLACK_SEAS: 'black-seas',
    BLOOD_RED_SKIES: 'blood-red-skies',
    K47: 'k47'
};

export const GAME_ROLE_RESTRICTIONS = {
    [GAME_IDS.K47]: 'k47-early-access'
};
